import React from 'react';
import styled from 'styled-components';
import { Flex, OHeaderTwo, OHeaderFive, Tooltip } from '@lifechurch/react-ion';
import AnalyticsOverviewTrend from './Overview/AnalyticsOverviewTrend';

interface Props {
  title: string;
  value: string;
  tooltip?: string;
  topPadding?: number;
  rightPadding?: number;
  leftPadding?: number;
  bottomPadding?: number;
  crossPadding?: number;
  backgroundColor?: string;
  borderRadius?: string;
  trendValue?: number;
}

const StyledFlex = styled(Flex)`
  min-height: 64px;
  button {
    margin-inline-start: 2px;
  }
  ${Flex} {
    margin-inline-start: auto;
  }
`;

const AnalyticsHorizontalStatBox: React.FC<Props> = ({
  title,
  value,
  tooltip,
  topPadding = 5,
  bottomPadding = 5,
  rightPadding = 0,
  leftPadding = 0,
  crossPadding = 5,
  backgroundColor = 'white',
  borderRadius = '2',
  trendValue,
}) => (
  <StyledFlex
    alignItems='center'
    paddingBlockStart={topPadding}
    paddingInlineEnd={rightPadding}
    paddingBlockEnd={bottomPadding}
    paddingInlineStart={leftPadding}
    px={crossPadding}
    backgroundColor={backgroundColor}
    borderRadius={borderRadius}
  >
    <OHeaderFive>{title}</OHeaderFive>
    {tooltip && <Tooltip content={tooltip} placement='top' />}
    <Flex>
      {trendValue && Number.isFinite(trendValue) ? (
        <AnalyticsOverviewTrend value={trendValue} />
      ) : (
        <AnalyticsOverviewTrend value={0} />
      )}
      <OHeaderTwo>{value}</OHeaderTwo>
    </Flex>
  </StyledFlex>
);

export default AnalyticsHorizontalStatBox;
